export const FETCH_AVAILABLE_APPLICATIONS = 'FETCH_AVAILABLE_APPLICATIONS';
export const FETCH_AVAILABLE_APPLICATIONS_STARTED = `${FETCH_AVAILABLE_APPLICATIONS}_STARTED`;
export const FETCH_AVAILABLE_APPLICATIONS_SUCCEED = `${FETCH_AVAILABLE_APPLICATIONS}_SUCCEED`;
export const FETCH_AVAILABLE_APPLICATIONS_FAILED = `${FETCH_AVAILABLE_APPLICATIONS}_FAILED`;
